import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ActionButton from '../helpers/ActionButton'
import ItemBlock from '../helpers/ItemBlock'
import SectionDivider from '../helpers/SectionDivider'
import SectionHeading from '../helpers/SectionHeading'
import { getAssociationRelationshipRole } from '../../../../person/relationships/AssociationsPanel'
import RelationshipPersonBlock from './RelationshipPersonBlock'

export default function OtherRelationships({ person, actionButtonOnClick }) {
  const { t } = useTranslation()
  return (
    <>
      {person?.associations && (
        <>
          <SectionHeading heading={t('tools.adminMerge.headings.otherRelationships', 'Other Relationships')} />
          {person?.associations.map((relationship, index) => {
            const actionButtonType = relationship.actionButtonType
            const actionButtonOnClickRelationship = () => {
              actionButtonOnClick({ item: 'Associations', actionButtonType, index })
            }

            const isPerson1 =
              relationship.value &&
              ['gender', 'lifespan', 'name', 'nameForms'].some((field) =>
                Object.keys(relationship.value.person1).includes(field)
              )
            const associationPerson = isPerson1 ? relationship.value?.person1 : relationship.value?.person2
            const personRole = isPerson1
              ? t('adminMerge.headings.person1', 'Person 1')
              : t('adminMerge.headings.person2', 'Person 2')
            return (
              <ItemBlock
                key={relationship.value?.relationshipId}
                selected={actionButtonType === 'UNDO'}
                displayStatus={relationship.displayStatus}
                isSurvivingPerson={person.isSurvivingPerson}
              >
                <DataBlock
                  heading={`${getAssociationRelationshipRole(
                    isPerson1,
                    relationship.value?.associationType,
                    t
                  )} (${personRole})`}
                  data={associationPerson?.personId && <RelationshipPersonBlock person={associationPerson} />}
                />
                <ActionButton type={actionButtonType} onClick={actionButtonOnClickRelationship} />
              </ItemBlock>
            )
          })}
          <SectionDivider />
        </>
      )}
    </>
  )
}
